/**
 * 基础菜单 会员列表
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>会员列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="模糊查询:">
        <el-input
          size="small"
          v-model="formInline.userName"
          placeholder="请输入手机号"
        ></el-input>
      </el-form-item>
      <!-- <el-form-item label="">
        <el-input size="small" v-model="formInline.deptNo" placeholder="输入部门代码"></el-input>
      </el-form-item> -->
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="search"
          >搜索</el-button
        >
        <el-button
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="addCode"
          >添加</el-button
        >
        <download-excel
      style="display: inline-block;"
        :data="listData"
        :fields="json_fields"
        type="xlse"
        worksheet="账号"
        name="账号数据"
      >
        <el-form-item>
          <el-button size="small" type="primary" style="margin-left: 10px;"
            >导出</el-button
          >
        </el-form-item>
      </download-excel>
        <!-- <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button> -->
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <!-- <el-table-column align="center" type="selection" width="60">
      </el-table-column> -->
      <el-table-column align="center" prop="id" label="ID" width="100">
      </el-table-column>
      <!-- <el-table-column align="center" prop="userName" label="用户" width="300">
      </el-table-column> -->
      <el-table-column align="center" prop="phone" width="120" label="账号">
      </el-table-column>
      <el-table-column align="center" prop="company"  width="120" label="密码">
    </el-table-column>
      <el-table-column align="center" prop="createTime" label="注册时间">
        <template slot-scope="scope">
          <div>{{ scope.row.createTime }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="loginTime" label="最近登录">
        <template slot-scope="scope">
          <div>{{ scope.row.loginTime }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="vipTime" label="到期时间">
        <template slot-scope="scope">
          <div>{{ scope.row.vipTime }}</div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="channelName"
        label="渠道"
        width="120"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="versionCode"
        label="版本"
       width="80"
      >
      </el-table-column>
      <el-table-column align="center"  width="120" label="操作" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">密码修改</el-button>
          <!-- <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination>

    <el-dialog
      :title="title"
      :visible.sync="addFormVisible"
      width="30%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @click="closeDialog('edit')"
    >
      <el-form
        label-width="100px"
        :model="addForm"
        :rules="rules"
        ref="addForm"
      >
        <el-form-item prop="firstUserName" label="账号第一段">
          <el-input
            size="small"
            v-model="addForm.firstUserName"
            auto-complete="off"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item prop="secondUserNameNum" label="账号第二段">
          <el-input
            size="small"
            v-model="addForm.secondUserNameNum"
            maxlength="1"
            placeholder="请输入账号第二段位数"
            auto-complete="off"
            type="number"
            disabled
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="时常" v-if="addForm.codeNum && addForm.type">
          <div>{{ addForm.codeNum + timeData }}</div>
        </el-form-item> -->

        <el-form-item prop="thirdUserName" label="账号第三段">
          <el-input
            size="small"
            v-model="addForm.thirdUserName"
            auto-complete="off"
            type="number"
            placeholder="请输入账号第三段开始数字"
          ></el-input>
        </el-form-item>
        <el-form-item prop="userCount" label="账号数量">
          <el-input
            size="small"
            type="number"
            placeholder="请输入生成账号数量"
            v-model="addForm.userCount"
            auto-complete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog('edit')">关闭</el-button>
        <!-- <el-form-item> -->
        <el-button size="mini" type="danger" @click="addCodeData('addForm')"
          >添加</el-button
        >
        <!-- </el-form-item> -->
      </div>
    </el-dialog>


    <el-dialog
      title="密码修改"
      :visible.sync="editFormVisible"
      width="30%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @click="closeDialog('edit')"
    >
      <el-form
        label-width="100px"
        :model="passwordData"
        :rules="passwordDatarules"
        ref="addForm"
      >
        <el-form-item prop="password" label="新密码">
          <el-input
            size="small"
            v-model="passwordData.password"
            auto-complete="off"
          placeholder="数字加字母,不少于8位"
          ></el-input>
        </el-form-item>
       
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeEditDialog('edit')">关闭</el-button>
        <!-- <el-form-item> -->
        <el-button size="mini" type="danger" @click="editPassword('addForm')"
          >修改</el-button
        >
        <!-- </el-form-item> -->
      </div>
    </el-dialog>



  </div>
</template>

<script>
import { vipList, deptSave,customerCreateBatch,customerChangePass } from "../../api/userMG";
import Pagination from "../../components/Pagination";
export default {
  data() {
    return {
        json_fields: {
        ID: "id", //常规字段
        账号: "phone", //支持嵌套属性
        密码: 'company',
        // 注册时间:'createTime',
        // 最近登录:'loginTime',
        // 到期时间:'vipTime',
    
      },
      passwordData:{
        userId:'',
        password:''
      },
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      addFormVisible: false,
      addForm: {
        // vid: "",
        firstUserName: "hc",
        secondUserNameNum: 3,
        thirdUserName: 10,
        userCount: "",
      },
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: "添加",
      editForm: {
        deptId: "",
        deptName: "",
        deptNo: "",
        token: localStorage.getItem("logintoken"),
      },
      // rules表单验证
      rules: {
        firstUserName: [
          { required: true, message: "请输入账号第一段", trigger: "blur" },
        ],
        secondUserNameNum: [
          { required: true, message: "请输入账号第二段位数", trigger: "blur" },
          // {
          //               pattern: /^[A-Z]{0,4}$/,
          //               message: '请输入大写英文字母，不能超过4位',
          //               trigger: 'change'
          //             }
        ],
        thirdUserName: [
          { required: true, message: "请输入账号第三段", trigger: "blur" },
        ],
        userCount: [
          { required: true, message: "请输入生成账号数量", trigger: "blur" },
        ],
      },
      passwordDatarules:{
     
        password: [
          { required: true, message: "新密码不能为空", trigger: "blur" },
          {
                        pattern: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/,
                        message: '数字加字母,不少于8位',
                        trigger: 'change'
                      }
        ],
 
      },
      formInline: {
        pageNo: 0,
        pageSize: 10,
        userName: null,
        varLable: "",
        varName: "",
        token: localStorage.getItem("logintoken"),
      },
      // 删除部门
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken"),
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline);
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    addCodeData(editData) {
      this.$refs[editData].validate((valid) => {
        if (valid) {
            customerCreateBatch(this.addForm).then((res) => {
            if (res.success) {
              this.getdata(this.formInline);
              this.$message({
                type: "success",
                message: "添加成功！",
              });
              this.addForm = {
                firstUserName: "hc",
                secondUserNameNum: 3,
                thirdUserName: 10,
                userCount: "",
              };
            } else {
              this.$message({
                type: "info",
                message: res.msg,
              });
            }
            this.addFormVisible = false;
            // console.log('添加成功')
          });
        } else {
          return false;
        }
      });
    },
    editPassword(editData){
        this.$refs[editData].validate((valid) => {
        if (valid) {
            customerChangePass(this.passwordData).then((res) => {
            if (res.success) {
              this.getdata(this.formInline);
              this.$message({
                type: "success",
                message: "修改成功！",
              });
              this.addForm = {
                firstUserName: "hc",
                secondUserNameNum: 3,
                thirdUserName: 10,
                userCount: "",
              };
            } else {
              this.$message({
                type: "info",
                message: res.msg,
              });
            }
            this.editFormVisible = false;
            // console.log('添加成功')
          });
        } else {
          return false;
        }
      });
    },
    // 获取公司列表
    getdata(parameter) {
      this.loading = true;
      // 模拟数据开始
      // let res = {
      //   code: 0,
      //   msg: null,
      //   count: 5,
      //   data: [
      //     {
      //       addUser: null,
      //       editUser: null,
      //       addTime: 1521062371000,
      //       editTime: 1526700200000,
      //       deptId: 2,
      //       deptName: 'XX分公司',
      //       deptNo: '1',
      //       parentId: 1
      //     },
      //     {
      //       addUser: null,
      //       editUser: null,
      //       addTime: 1521063247000,
      //       editTime: 1526652291000,
      //       deptId: 3,
      //       deptName: '上海测试',
      //       deptNo: '02',
      //       parentId: 1
      //     },
      //     {
      //       addUser: null,
      //       editUser: null,
      //       addTime: 1526349555000,
      //       editTime: 1526349565000,
      //       deptId: 12,
      //       deptName: '1',
      //       deptNo: '11',
      //       parentId: 1
      //     },
      //     {
      //       addUser: null,
      //       editUser: null,
      //       addTime: 1526373178000,
      //       editTime: 1526373178000,
      //       deptId: 13,
      //       deptName: '5',
      //       deptNo: '5',
      //       parentId: 1
      //     },
      //     {
      //       addUser: null,
      //       editUser: null,
      //       addTime: 1526453107000,
      //       editTime: 1526453107000,
      //       deptId: 17,
      //       deptName: 'v',
      //       deptNo: 'v',
      //       parentId: 1
      //     }
      //   ]
      // }
      // this.loading = false
      // this.listData = res.data
      // this.pageparm.currentPage = this.formInline.page
      // this.pageparm.pageSize = this.formInline.pageSize
      // this.pageparm.total = res.count
      // 模拟数据结束

      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      let data = { ...parameter };
      vipList(data)
        .then((res) => {
			console.log(res)
          this.loading = false;
          if (res.success == false) {
            this.$message({
              type: "info",
              message: res.message,
            });
          } else {
            this.listData = res.data.records;
            // 分页赋值
            // this.pageparm.currentPage = res.data.pageIndex
            this.pageparm.pageSize = res.data.size;
            this.pageparm.total = res.data.total;
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("菜单加载失败，请稍后再试！");
        });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.pageNo = parm.currentPage - 1;
      this.formInline.pageSize = parm.pageSize;
      this.getdata(this.formInline);
    },
    // 搜索事件
    search() {
      this.formInline.pageNo = 0;
      this.getdata(this.formInline);
    },
    addCode: function (index, row) {
      this.addFormVisible = true;
      //   this.addForm = row
      //   this.money = this.addForm.goodsMoney * 1
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true;
      this.passwordData.userId = row.id
    //   if (row != undefined && row != "undefined") {
    //     this.title = "修改";
    //     this.editForm.deptId = row.deptId;
    //     this.editForm.deptName = row.deptName;
    //     this.editForm.deptNo = row.deptNo;
    //   } else {
    //     this.title = "添加";
    //     this.editForm.deptId = "";
    //     this.editForm.deptName = "";
    //     this.editForm.deptNo = "";
    //   }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate((valid) => {
        if (valid) {
          // deptSave(this.editForm)
          //   .then(res => {
          //     this.editFormVisible = false
          //     this.loading = false
          //     if (res.success) {
          //       this.getdata(this.formInline)
          //       this.$message({
          //         type: 'success',
          //         message: '公司保存成功！'
          //       })
          //     } else {
          //       this.$message({
          //         type: 'info',
          //         message: res.msg
          //       })
          //     }
          //   })
          //   .catch(err => {
          //     this.editFormVisible = false
          //     this.loading = false
          //     this.$message.error('公司保存失败，请稍后再试！')
          //   })
        } else {
          return false;
        }
      });
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // deptDelete(row.deptId)
          //   .then(res => {
          //     if (res.success) {
          //       this.$message({
          //         type: 'success',
          //         message: '公司已删除!'
          //       })
          //       this.getdata(this.formInline)
          //     } else {
          //       this.$message({
          //         type: 'info',
          //         message: res.msg
          //       })
          //     }
          //   })
          //   .catch(err => {
          //     this.loading = false
          //     this.$message.error('公司删除失败，请稍后再试！')
          //   })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.addFormVisible = false;
    },
    closeEditDialog() {
      this.editFormVisible = false;
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
.userRole {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/goods/channeluser.vue